import styled from "styled-components"

import { breakpoint, spacing } from "@minuthq/meatball-ui-react"

import { ImageBackdrop } from "src/components/ImageBackdrop/ImageBackdrop"
import { DocumentHead } from "src/router/DocumentHead"
import { MCard } from "src/ui/MCard/MCard"

export function BackdropView({
  children,
  title,
  landscapeImageUrl,
  portraitImageUrl,
}: {
  title: string
  children: React.ReactNode
  landscapeImageUrl: string
  portraitImageUrl: string
}) {
  return (
    <Box>
      <DocumentHead title={title} />

      <ImageBackdrop
        landscapeImageUrl={landscapeImageUrl}
        portraitImageUrl={portraitImageUrl}
      >
        <StyledCard>{children}</StyledCard>
      </ImageBackdrop>
    </Box>
  )
}

const desktopUp = breakpoint.mediumUp

const Box = styled.div`
  position: relative;
`

const StyledCard = styled(MCard)`
  max-width: 650px;
  padding: ${spacing.L} ${spacing.L};
  @media (${desktopUp}) {
    padding: ${spacing.XL};
  }
`
